import { useState } from "react";
import { ArrowRight, Check, Heart, MessageCircle, Shield, Leaf, Truck, RefreshCw, Lock, ChevronLeft, ChevronRight } from "lucide-react";
import { C, SERIF, SANS, REVIEWS, ARTICLES } from "../lib/constants";
import { Btn, Stars, Eyebrow, ImgPh } from "../components/Primitives";
import { useSEO } from "../lib/useSEO";
import { SEO } from "../lib/seoRoutes";

export default function HomePage({ go }) {
  useSEO(SEO.home);
  const [hotspot, setHotspot] = useState(null);
  const [slider, setSlider] = useState(50);
  const HOTSPOTS = [
    { x: 22, y: 55, t: "Soft cotton panty inside", d: "Full-brief cut with elasticated waist — sits like your favourite underwear" },
    { x: 50, y: 42, t: "4EVER Freedom pack", d: "5 individually wrapped panties, dermatologist tested, OEKO-TEX certified" },
    { x: 82, y: 30, t: "Naturally derived materials", d: "No fragrance, no chlorine bleach, nothing you can't pronounce" },
    { x: 82, y: 72, t: "Discreet to pack, hygienic to dispose", d: "Individually wrapped for travel, work, and overnight peace of mind" },
  ];
  return (
    <div>
      {/* HERO */}
      <section style={{ maxWidth: 1240, margin: "0 auto", padding: "72px 28px 56px",
        display: "grid", gridTemplateColumns: "1fr 1fr", gap: 56, alignItems: "center" }}>
        <div>
          <Eyebrow>A Home, Not A Store</Eyebrow>
          <h1 style={{ fontFamily: SERIF, fontSize: 54, lineHeight: 1.08, color: C.dark,
            margin: "0 0 16px", fontWeight: 400 }}>
            Made for the days <em style={{ color: C.coral }}>only you</em> understand.
          </h1>
          <p style={{ fontFamily: SANS, fontSize: 15, color: C.muted, lineHeight: 1.8,
            margin: "0 0 22px", maxWidth: 420 }}>
            Disposable period panties, a tracker that whispers, and a community
            that gets it — built around how women actually feel.
          </p>
          <div style={{ marginBottom: 22, fontFamily: SANS, background: C.cream,
            borderRadius: 8, padding: "11px 16px", display: "inline-block" }}>
            <span style={{ fontSize: 22, fontWeight: 800, color: C.dark }}>₹299</span>
            <span style={{ fontSize: 13, color: C.muted, marginLeft: 6 }}>pack of 5</span>
            <span style={{ display: "block", fontSize: 12, color: C.coral,
              fontWeight: 600, marginTop: 2 }}>₹254 with Subscribe & Save</span>
          </div>
          <div style={{ display: "flex", gap: 12, marginBottom: 24 }}>
            <Btn size="lg" onClick={() => go("product")}>
              Shop The Panty <ArrowRight size={15} /></Btn>
            <Btn variant="secondary" size="lg" onClick={() => go("story")}>Our Story</Btn>
          </div>
          <div style={{ display: "flex", gap: 18, flexWrap: "wrap" }}>
            {[[<Shield size={13} />, "Dermatologist tested"],
              [<Check size={13} />, "OEKO-TEX certified"],
              [<Leaf size={13} />, "Made with care in India"]].map(([i, t]) => (
              <span key={t} style={{ display: "flex", alignItems: "center", gap: 6,
                fontFamily: SANS, fontSize: 12, color: C.muted }}>
                <span style={{ color: C.coral }}>{i}</span>{t}
              </span>
            ))}
          </div>
        </div>
        <div style={{ position: "relative" }}>
          <img src="/img/hero.png" alt="4Ever lifestyle" style={{
            width: "100%", height: 460, objectFit: "cover", borderRadius: 16, display: "block",
          }} onError={(e) => { e.target.style.display = "none"; }} />
          <div style={{ position: "absolute", bottom: 20, left: 20, background: C.white,
            borderRadius: 10, padding: "10px 16px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)" }}>
            <div style={{ fontFamily: SANS, fontSize: 11, fontWeight: 600, color: C.dark }}>
              Up to 12 hours* worry-free wear, depending on usage</div>
          </div>
          <div style={{ position: "absolute", top: 20, right: 20, background: C.coral,
            borderRadius: 10, padding: "11px 15px", maxWidth: 180, color: "#fff" }}>
            <div style={{ fontFamily: SANS, fontSize: 9, fontWeight: 700,
              letterSpacing: 1, marginBottom: 3, opacity: 0.85 }}>ONLY ON 4EVER</div>
            <div style={{ fontFamily: SANS, fontSize: 12, lineHeight: 1.5 }}>
              Delivery synced to your period tracker</div>
          </div>
        </div>
      </section>

      {/* TRUST BAR */}
      <div style={{ borderTop: `1px solid ${C.border}`, borderBottom: `1px solid ${C.border}`,
        background: C.white }}>
        <div style={{ maxWidth: 1240, margin: "0 auto", padding: "18px 28px",
          display: "flex", justifyContent: "space-evenly", flexWrap: "wrap", gap: 18 }}>
          {[[<Shield size={15} />, "Dermatologist Tested"],
            [<Leaf size={15} />, "No Toxins · No Fragrance"],
            [<Truck size={15} />, "Free Shipping ₹999+"],
            [<RefreshCw size={15} />, "7-Day Returns"],
            [<Lock size={15} />, "Data Encrypted Always"]].map(([i, t]) => (
            <span key={t} style={{ display: "flex", alignItems: "center", gap: 8,
              fontFamily: SANS, fontSize: 12, color: C.dark, fontWeight: 500 }}>
              <span style={{ color: C.coral }}>{i}</span>{t}
            </span>
          ))}
        </div>
      </div>

      {/* PROMISE */}
      <section style={{ background: C.lightBg, padding: "68px 28px" }}>
        <div style={{ maxWidth: 860, margin: "0 auto", textAlign: "center" }}>
          <Eyebrow>Our Promise</Eyebrow>
          <blockquote style={{ fontFamily: SERIF, fontSize: 36, lineHeight: 1.3,
            color: C.dark, margin: "0 0 24px", fontWeight: 400 }}>
            “Periods aren't a problem to solve. They're a rhythm to respect.”
          </blockquote>
          <p style={{ fontFamily: SANS, fontSize: 14, color: C.muted, lineHeight: 1.85,
            maxWidth: 580, margin: "0 auto" }}>
            We build products — and a place — that treat women like the whole,
            capable, feeling humans they are.
          </p>
        </div>
      </section>

      {/* PRODUCT FEATURE */}
      <section style={{ maxWidth: 1240, margin: "0 auto", padding: "76px 28px",
        display: "grid", gridTemplateColumns: "1fr 1fr", gap: 56, alignItems: "center" }}>
        <div>
          <Eyebrow>The First Chapter</Eyebrow>
          <h2 style={{ fontFamily: SERIF, fontSize: 40, lineHeight: 1.15, color: C.dark,
            fontWeight: 400, margin: "0 0 14px" }}>
            Disposable Period Panties, made the way they should have always been made.
          </h2>
          <p style={{ fontFamily: SANS, fontSize: 14, color: C.muted, lineHeight: 1.85,
            margin: "0 0 26px" }}>
            Soft against the skin. Quietly powerful where it matters. Wear overnight,
            on a long flight, through a heavy day — then let them go.
            No stains, no shifting, no compromise.
          </p>
          {[
            ["Up to 12 hours* of worry-free wear", "Sleep, travel, work, and forget it's there. Leak-proof core holds up to 40ml. *Depending on usage."],
            ["Skin-safe, breathable layers", "No fragrance. No chlorine bleach. Nothing you can't pronounce."],
            ["Fits like your favourite underwear", "Full-coverage brief cut. No bulk, no waistband dig."],
            ["Individually wrapped", "Discreet to pack, dignified to use, hygienic to dispose."],
          ].map(([t, d]) => (
            <div key={t} style={{ display: "flex", gap: 14, marginBottom: 16 }}>
              <div style={{ width: 28, height: 28, borderRadius: "50%", background: C.coralBg,
                display: "flex", alignItems: "center", justifyContent: "center",
                flexShrink: 0, marginTop: 2 }}>
                <Check size={12} color={C.coral} />
              </div>
              <div>
                <div style={{ fontFamily: SANS, fontSize: 14, fontWeight: 600,
                  color: C.dark, marginBottom: 2 }}>{t}</div>
                <div style={{ fontFamily: SANS, fontSize: 13, color: C.muted,
                  lineHeight: 1.6 }}>{d}</div>
              </div>
            </div>
          ))}
          <div style={{ display: "flex", gap: 12, marginTop: 28 }}>
            <Btn size="lg" onClick={() => go("product")}>Explore The Panty</Btn>
            <Btn variant="secondary" size="lg" onClick={() => go("product")}>
              Subscribe & Save 15%</Btn>
          </div>
        </div>
        <img src="/img/product_flat.png" alt="4Ever product" style={{
          width: "100%", height: 440, objectFit: "cover", borderRadius: 16, display: "block",
        }} onError={(e) => { e.target.style.display = "none"; }} />
      </section>

      {/* IMAGE HOTSPOT */}
      <section style={{ maxWidth: 1240, margin: "0 auto", padding: "0 28px 76px" }}>
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <Eyebrow>The Panty</Eyebrow>
          <h2 style={{ fontFamily: SERIF, fontSize: 36, color: C.dark, fontWeight: 400,
            margin: 0 }}>Every layer, explained.</h2>
        </div>
        <div style={{ position: "relative", background: C.cream, borderRadius: 16,
          height: 420, maxWidth: 820, margin: "0 auto", overflow: "hidden" }}>
          <img src="/img/layers.png" alt="4Ever construction layers" style={{
            position: "absolute", inset: 0, width: "100%", height: "100%",
            objectFit: "cover", display: "block",
          }} onError={(e) => { e.target.style.display = "none"; }} />
          {HOTSPOTS.map((h, i) => (
            <div key={i} style={{ position: "absolute", left: `${h.x}%`, top: `${h.y}%` }}>
              <button onClick={() => setHotspot(hotspot === i ? null : i)} style={{
                width: 28, height: 28, borderRadius: "50%", border: "3px solid #fff",
                background: C.coral, cursor: "pointer",
                boxShadow: "0 2px 12px rgba(197,96,58,0.4)", color: "#fff",
                fontFamily: SANS, fontSize: 14, fontWeight: 700, display: "flex",
                alignItems: "center", justifyContent: "center" }}>
                {hotspot === i ? "−" : "+"}
              </button>
              {hotspot === i && (
                <div style={{ position: "absolute", top: 34, left: -90, width: 220,
                  background: C.white, borderRadius: 10, padding: "12px 15px",
                  boxShadow: "0 8px 32px rgba(0,0,0,0.14)", zIndex: 20 }}>
                  <div style={{ fontFamily: SANS, fontSize: 13, fontWeight: 700,
                    color: C.dark, marginBottom: 3 }}>{h.t}</div>
                  <div style={{ fontFamily: SANS, fontSize: 12, color: C.muted,
                    lineHeight: 1.55 }}>{h.d}</div>
                </div>
              )}
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: 12, fontFamily: SANS, fontSize: 12,
          color: C.mutedLt }}>Tap the dots to explore</div>
      </section>

      {/* BEFORE / AFTER */}
      <section style={{ maxWidth: 1240, margin: "0 auto", padding: "0 28px 76px" }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <h2 style={{ fontFamily: SERIF, fontSize: 36, color: C.dark, fontWeight: 400,
            margin: "0 0 6px" }}>The night, before and after.</h2>
          <p style={{ fontFamily: SANS, fontSize: 13, color: C.muted, margin: 0 }}>
            Drag to compare</p>
        </div>
        <div style={{ position: "relative", height: 420, borderRadius: 16,
          overflow: "hidden", maxWidth: 880, margin: "0 auto" }}>
          {/* BEFORE image (full width) */}
          <img src="/img/before.png" alt="Before 4Ever" style={{
            position: "absolute", inset: 0, width: "100%", height: "100%",
            objectFit: "cover", display: "block",
          }} onError={(e) => { e.target.style.display = "none"; }} />
          <div style={{ position: "absolute", inset: 0,
            background: "linear-gradient(90deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.05) 60%)",
            display: "flex", alignItems: "flex-end", paddingLeft: 32, paddingBottom: 26 }}>
            <div style={{ fontFamily: SANS, fontSize: 14, color: "#fff" }}>
              <div style={{ fontSize: 10, letterSpacing: 2, textTransform: "uppercase",
                marginBottom: 6, fontWeight: 700, opacity: 0.9 }}>Before</div>
              A regular night —<br />waking to check, worrying about sheets
            </div>
          </div>
          {/* AFTER image, clipped */}
          <div style={{ position: "absolute", inset: 0,
            clipPath: `inset(0 0 0 ${slider}%)`, overflow: "hidden" }}>
            <img src="/img/after.png" alt="After 4Ever" style={{
              width: "100%", height: "100%", objectFit: "cover", display: "block",
            }} onError={(e) => { e.target.style.display = "none"; }} />
            <div style={{ position: "absolute", inset: 0,
              background: "linear-gradient(270deg, rgba(197,96,58,0.35) 0%, rgba(197,96,58,0.05) 60%)",
              display: "flex", alignItems: "flex-end", justifyContent: "flex-end",
              paddingRight: 32, paddingBottom: 26 }}>
              <div style={{ fontFamily: SANS, fontSize: 14, color: "#fff", textAlign: "right" }}>
                <div style={{ fontSize: 10, letterSpacing: 2, textTransform: "uppercase",
                  marginBottom: 6, fontWeight: 700, opacity: 0.95 }}>After</div>
                A 4Ever night —<br />asleep, and it stays that way
              </div>
            </div>
          </div>
          <input type="range" min="10" max="90" value={slider}
            onChange={e => setSlider(Number(e.target.value))}
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%",
              opacity: 0, cursor: "ew-resize", zIndex: 10 }} />
          <div style={{ position: "absolute", top: 0, bottom: 0, left: `${slider}%`,
            width: 3, background: "#fff", boxShadow: "0 0 12px rgba(0,0,0,0.2)",
            pointerEvents: "none" }}>
            <div style={{ position: "absolute", top: "50%", left: "50%",
              transform: "translate(-50%,-50%)", width: 38, height: 38,
              borderRadius: "50%", background: "#fff", display: "flex",
              alignItems: "center", justifyContent: "center",
              boxShadow: "0 2px 12px rgba(0,0,0,0.2)" }}>
              <ChevronLeft size={12} color={C.dark} /><ChevronRight size={12} color={C.dark} />
            </div>
          </div>
        </div>
      </section>

      {/* REVIEWS section removed until real customer reviews arrive */}

      {/* TRACKER PROMO (dark) */}
      <section style={{ background: C.dark2, padding: "72px 0" }}>
        <div style={{ maxWidth: 1240, margin: "0 auto", padding: "0 28px",
          display: "grid", gridTemplateColumns: "1fr 1fr", gap: 56, alignItems: "center" }}>
          <div>
            <Eyebrow color="#F0B8A0">Your Cycle, Gently Understood</Eyebrow>
            <h2 style={{ fontFamily: SERIF, fontSize: 38, color: "#fff", fontWeight: 400,
              margin: "0 0 14px", lineHeight: 1.15 }}>
              A tracker that guides,<br />never nags.
            </h2>
            <p style={{ fontFamily: SANS, fontSize: 14, color: "#A89D96",
              lineHeight: 1.85, margin: "0 0 20px" }}>
              Log how you feel in 20 seconds. We learn your rhythm — and time your
              delivery so your comfort kit arrives before you need it.
            </p>
            <div style={{ background: "rgba(240,184,160,0.1)", borderRadius: 10,
              padding: "14px 18px", marginBottom: 24,
              borderLeft: "3px solid #F0B8A0" }}>
              <div style={{ fontFamily: SANS, fontSize: 12, fontWeight: 700,
                color: "#F0B8A0", marginBottom: 4 }}>✨ Only on 4Ever</div>
              <div style={{ fontFamily: SANS, fontSize: 13, color: "#D4CFC8",
                lineHeight: 1.65 }}>
                When you subscribe, your panties arrive 2 days before your
                predicted period — automatically.
              </div>
            </div>
            <Btn variant="white" size="lg" onClick={() => go("tracker")}>
              Open Your Tracker <ArrowRight size={15} /></Btn>
          </div>
          <div style={{ background: "rgba(255,255,255,0.05)", borderRadius: 16,
            border: "1px solid rgba(255,255,255,0.09)", padding: 24 }}>
            <div style={{ fontFamily: SANS, fontSize: 9, letterSpacing: 2,
              color: "#F0B8A0", textTransform: "uppercase", marginBottom: 6 }}>
              Day 5 · Menstrual phase</div>
            <div style={{ fontFamily: SERIF, fontSize: 24, color: "#fff",
              marginBottom: 8 }}>Rest is the work.</div>
            <div style={{ fontFamily: SANS, fontSize: 12, color: "#A89D96",
              marginBottom: 16, lineHeight: 1.6 }}>
              Next period in 23 days · Comfort kit ships Aug 5, synced to your cycle
            </div>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              {["Iron-rich foods", "Gentle movement", "Prioritise warmth"].map(c => (
                <span key={c} style={{ fontFamily: SANS, fontSize: 11,
                  background: "rgba(240,184,160,0.14)", color: "#F0B8A0",
                  padding: "5px 12px", borderRadius: 14 }}>{c}</span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* COMMUNITY TEASE (dark continues) */}
      <section style={{ background: C.dark2, padding: "0 0 72px" }}>
        <div style={{ maxWidth: 1240, margin: "0 auto", padding: "0 28px",
          borderTop: "1px solid rgba(255,255,255,0.08)", paddingTop: 64,
          display: "grid", gridTemplateColumns: "1fr 1fr", gap: 56, alignItems: "center" }}>
          <div style={{ background: "rgba(255,255,255,0.04)",
            borderRadius: 12, padding: "28px 30px",
            border: "1px solid rgba(255,255,255,0.07)" }}>
            <div style={{ fontFamily: SANS, fontSize: 9, letterSpacing: 1.5,
              color: C.coral, textTransform: "uppercase", marginBottom: 10 }}>PCOS · Anonymous</div>
            <p style={{ fontFamily: SERIF, fontSize: 22, color: "#EDE5DC",
              lineHeight: 1.5, margin: "0 0 14px", fontStyle: "italic" }}>
              "This is where I get to say the things I can't say anywhere else."
            </p>
            <div style={{ fontFamily: SANS, fontSize: 12, color: "#8A8380",
              lineHeight: 1.7 }}>
              A safe, moderated place to ask, share and be heard — trained
              women's health professionals watching over every circle.
            </div>
          </div>
          <div>
            <Eyebrow color="#F0B8A0">Community</Eyebrow>
            <h2 style={{ fontFamily: SERIF, fontSize: 38, color: "#fff", fontWeight: 400,
              margin: "0 0 14px", lineHeight: 1.15 }}>
              A room where nothing<br />is too much to say.
            </h2>
            <p style={{ fontFamily: SANS, fontSize: 14, color: "#A89D96",
              lineHeight: 1.85, margin: "0 0 24px" }}>
              Post anonymously. Moderated by trained women's health professionals.
              Zero judgement — this space is only just beginning.
            </p>
            <Btn variant="white" size="lg" onClick={() => go("community")}>
              Enter The Community <ArrowRight size={15} /></Btn>
          </div>
        </div>
      </section>

      {/* JOURNAL PREVIEW */}
      <section style={{ maxWidth: 1240, margin: "0 auto", padding: "64px 28px" }}>
        <div style={{ display: "flex", justifyContent: "space-between",
          alignItems: "baseline", marginBottom: 32 }}>
          <h2 style={{ fontFamily: SERIF, fontSize: 32, color: C.dark, fontWeight: 400,
            margin: 0 }}>Slow reading for fast lives.</h2>
          <span onClick={() => go("journal")} style={{ fontFamily: SANS, fontSize: 13,
            color: C.coral, cursor: "pointer" }}>All articles →</span>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 24 }}>
          {ARTICLES.slice(0, 3).map(a => (
            <a key={a.id} href={`/journal/${a.slug}`} data-testid={`home-journal-card-${a.slug}`}
              style={{ cursor: "pointer", textDecoration: "none", color: "inherit", display: "block" }}
              onClick={(e) => { e.preventDefault(); go(`journal/${a.slug}`); }}>
              <img src="/img/journal.png" alt="" style={{ width: "100%", height: 160,
                objectFit: "cover", borderRadius: 12, display: "block" }}
                onError={(e) => { e.target.style.display = "none"; }} />
              <div style={{ fontFamily: SANS, fontSize: 9, letterSpacing: 2,
                color: C.coral, textTransform: "uppercase", margin: "12px 0 5px" }}>{a.cat}</div>
              <div style={{ fontFamily: SERIF, fontSize: 18, color: C.dark,
                lineHeight: 1.3, marginBottom: 8 }}>{a.title}</div>
              <div style={{ fontFamily: SANS, fontSize: 11, color: C.dark,
                fontWeight: 600 }}>By {a.author}</div>
              <div style={{ fontFamily: SANS, fontSize: 11, color: C.mutedLt }}>
                {a.role} · {a.date} · {a.read}</div>
            </a>
          ))}
        </div>
      </section>

      {/* NEWSLETTER */}
      <NewsletterSection />
    </div>
  );
}

function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  const submit = async () => {
    if (!email) return;
    try {
      const { newsletterApi } = await import("../lib/api");
      await newsletterApi.subscribe(email);
      setStatus("ok"); setEmail("");
    } catch { setStatus("err"); }
  };
  return (
      <section style={{ background: C.coralBg, padding: "56px 28px" }}>
        <div style={{ maxWidth: 520, margin: "0 auto", textAlign: "center" }}>
          <h2 style={{ fontFamily: SERIF, fontSize: 30, color: C.dark, fontWeight: 400,
            margin: "0 0 8px" }}>The Sunday Letter</h2>
          <p style={{ fontFamily: SANS, fontSize: 14, color: C.muted, margin: "0 0 22px" }}>
            One quiet email, once a week. Never a promotion in disguise.
          </p>
          <div style={{ display: "flex", gap: 8 }}>
            <input value={email} onChange={e => setEmail(e.target.value)}
              placeholder="your@email.com" style={{ flex: 1, padding: "13px 16px",
              border: `1px solid ${C.border}`, borderRadius: 4, fontFamily: SANS,
              fontSize: 13, background: "#fff", outline: "none" }} />
            <Btn onClick={submit}>Subscribe</Btn>
          </div>
          <p style={{ fontFamily: SANS, fontSize: 11, color: status === "ok" ? C.green : C.mutedLt, marginTop: 10 }}>
            {status === "ok"
              ? "You're in. See you Sunday."
              : status === "err"
              ? "Something went wrong. Please try again."
              : "We'll never share your address. Unsubscribe any time."}
          </p>
        </div>
      </section>
  );
}
